export const messages = {
    "wr-dashboard.search.input.hint": "Suchen",
    "wr-dashboard.search.label.breadcrumb": "Suchergebnisse",
    "wr-dashboard.search.message.empty": "Keine Elemente entsprechen Ihren Suchkriterien",
    "wr-dashboard.side-bar.selected.title:plural": "{count} Elemente ausgewählt | {count} Element ausgewählt | {count} Elemente ausgewählt",
    "wr-dashboard.side-bar.backup-type.disk": "Laufwerk",
    "wr-dashboard.side-bar.backup-type.file": "Datei",
    "wr-dashboard.side-bar.backup-type.notarized": "Beglaubigte Dateien und Ordner",
    "wr-dashboard.side-bar.backup-type.exchange": "Applikation – Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Applikation – Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Applikation – Systemzustand",
    "wr-dashboard.side-bar.backup-type.application": "Applikation",
    "wr-dashboard.backups-table.column.name": "Name",
    "wr-dashboard.backups-table.column.size": "Größe",
    "wr-dashboard.backups-table.column.version": "Letzte Version",
    "wr-dashboard.backups-table.action.delete": "Löschen",
    "wr-dashboard.backups-table.message.no-backups": "Es gibt noch keine Backups in der Cloud",
    "wr-dashboard.backups-sidebar.label.size": "Größe",
    "wr-dashboard.backups-sidebar.label.type": "Typ",
    "wr-dashboard.backups-sidebar.label.version": "Letzte Version",
    "wr-dashboard.backups-sidebar.label.created": "Erstellt",
    "wr-dashboard.backups-sidebar.label.machine": "Maschine",
    "wr-dashboard.backups-sidebar.label.owner": "Besitzer",
    "wr-dashboard.content-table.column.name": "Name",
    "wr-dashboard.content-table.column.versions": "Versionen",
    "wr-dashboard.content-table.column.volumes": "Volumes",
    "wr-dashboard.content-table.column.path": "Pfad",
    "wr-dashboard.content-table.column.size": "Größe",
    "wr-dashboard.content-table.column.version": "Letzte Version",
    "wr-dashboard.content-table.action.notary-verify": "Verifizieren",
    "wr-dashboard.content-table.action.notary-get-crt": "Zertifikat abrufen",
    "wr-dashboard.content-table.action.asign": "Zur Unterschrift senden",
    "wr-dashboard.content-table.action.versions": "Versionen",
    "wr-dashboard.content-table.action.restore": "Download",
    "wr-dashboard.content-table.label.size": "Größe",
    "wr-dashboard.content-table.label.created": "Erstellt",
    "wr-dashboard.content-table.label.modified": "Geändert",
    "wr-dashboard.content-table.message.empty-folder": "Dieser Ordner ist leer",
    "wr-dashboard.password-dialog-box.title.backup": "Verschlüsseltes Backup",
    "wr-dashboard.password-dialog-box.title.archive": "Verschlüsseltes Archiv",
    "wr-dashboard.password-dialog-box.message.backup": "Spezifizieren Sie das Kennwort, um auf das Backup '{displayName}' zugreifen zu können",
    "wr-dashboard.password-dialog-box.message.archive": "Spezifizieren Sie das Kennwort, um auf das Archiv '{displayName}' zugreifen zu können",
    "wr-dashboard.password-dialog-box.hint.password": "Kennwort",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Das Kennwort ist falsch",
    "wr-dashboard.form.button.open": "Öffnen",
    "wr-dashboard.form.button.close": "Schließen",
    "wr-dashboard.form.button.cancel": "Abbrechen",
    "wr-dashboard.form.button.continue": "Weiter",
    "wr-dashboard.form.button.proceed": "Fortsetzen",
    "wr-dashboard.form.button.delete": "Löschen",
    "wr-dashboard.form.button.done": "Fertig",
    "wr-dashboard.form.button.retry": "Wiederholen",
    "wr-dashboard.notary.verify.view.status.downloading": "Wird heruntergeladen...",
    "wr-dashboard.notary.verify.view.status.validating": "Wird validiert...",
    "wr-dashboard.notary.verify.view.status.pending": "Ausstehendes Zertifikat...",
    "wr-dashboard.notary.verify.view.status.fail": "Zertifikatskonflikt...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Zertifikat abrufen",
    "wr-dashboard.notary.verify.view.file-info.name": "NAME",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "SIGNIERT VON",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "BACKUP-DATUM",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "BEGLAUBIGUNGSDATUM",
    "wr-dashboard.notary.verify.view.button.cancel": "Abbrechen",
    "wr-dashboard.notary.verify.view.button.done": "Fertig",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Nicht unterstützte Browser-Version",
    "wr-dashboard.versions-dialog-box.title": "Versionen von {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Zur Unterschrift senden",
    "wr-dashboard.asign-dialog-box.message": "Die Dateiversion ist freigegeben. Aber ohne den Link auf diese kann niemand die Datei einsehen. Fahren Sie mit ASign fort, um Unterzeichner hinzuzufügen und den Link freizugeben.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Dateidetails anzeigen",
    "wr-dashboard.page-not-found.title": "Die Seite wurde nicht gefunden",
    "wr-dashboard.page-not-found.message.main": "Die von Ihnen gesuchte Seite konnte nicht gefunden werden.",
    "wr-dashboard.page-not-found.message.description": "Entweder ist der Link veraltet oder Sie haben die Adresse falsch eingegeben.",
    "wr-dashboard.page-not-found.message.error": "Fehlercode: 404",
    "wr-dashboard.server-error.title": "Der Server ist nicht verfügbar",
    "wr-dashboard.server-error.message": "Der Server ist derzeit nicht verfügbar. Versuchen Sie es später noch einmal.",
    "wr-dashboard.server-error.message.error": "Fehlercode: 500",
    "wr-dashboard.account-menu.action.sign-out": "Abmelden",
    "wr-dashboard.breadcrumb.item.machines": "Maschinen",
    "wr-dashboard.breadcrumb.item.failed-backups": "Fehlgeschlagene Backups",
    "wr-dashboard.machines-table.column.name": "Name",
    "wr-dashboard.machines-table.column.size": "Größe",
    "wr-dashboard.machines-table.message.no-machines": "Es gibt noch keine Maschinen in der Cloud",
    "wr-dashboard.incomplete-backups.message.status:plural": "Sie haben {count} fehlgeschlagene oder unvollständige Backups, die {size} Speicherplatz belegen | Sie haben {count} fehlgeschlagenes oder unvollständiges Backup, das {size} Speicherplatz belegt | Sie haben {count} fehlgeschlagene oder unvollständige Backups, die {size} Speicherplatz belegen",
    "wr-dashboard.incomplete-backups.button.view": "Backups anzeigen",
    "wr-dashboard.incomplete-backups.button.delete": "Backups löschen",
    "wr-dashboard.machines-table.message.space-used:plural": "Backup-Nutzung insgesamt: {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Archive löschen",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Unvollständige Archive löschen",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Alle unvollständigen Archive löschen",
    "wr-dashboard.delete-archive.message": "Wollen Sie die ausgewählten Archive wirklich von allen Speicherorten endgültig löschen? Alle Daten werden vollständig gelöscht und können nicht wiederhergestellt werden.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Zertifikat steht noch aus",
    "wr-dashboard.certificate-pending-dialog-box.message": "Versuchen Sie es in ein paar Minuten erneut.",
    "wr-dashboard.form.button.ok": "OK"
};
